import { IApplicationState } from '../../types/redux';
import { ENewReviewModalStep } from '../../types/newReview';

export const getIsPrevStepAvailable = (state: IApplicationState): boolean => {
  return state.newReview.meta.step === ENewReviewModalStep.Review;
};
